import React from 'react';
import { FadeIn } from './FadeIn';
import { Clock } from 'lucide-react';
export function Hook() {
  return <section className="py-20 bg-tactical-panel border-b border-tactical-border relative" data-id="element-116">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-117">
        <FadeIn data-id="element-118">
          <div className="relative bg-tactical-dark p-8 sm:p-12 border border-tactical-border" data-id="element-119">
            {/* Top left accent */}
            <div className="absolute top-0 left-0 w-16 h-1 bg-tactical-accent" data-id="element-120"></div>

            <div className="flex items-center gap-3 mb-6 text-tactical-accent font-mono" data-id="element-121">
              <Clock className="w-5 h-5" data-id="element-122" />
              <span className="tracking-widest uppercase" data-id="element-123">
                11:30 PM. Status: Crítico.
              </span>
            </div>

            <div className="space-y-6 text-lg sm:text-xl text-zinc-300 leading-relaxed font-serif italic" data-id="element-124">
              <p data-id="element-125">
                "Estás en la cama, mirando el techo, con una presión en el pecho
                que ya conoces. Has pasado todo el día 'ocupado', pero al cerrar
                los ojos sabes la verdad: no has avanzado ni un centímetro hacia
                la vida que prometiste construir."
              </p>
              <p data-id="element-126">
                "Esa frustración no es falta de capacidad, es exceso de
                pensamiento. Estás atrapado en un ciclo de análisis que drena tu
                energía, vacía tu cuenta bancaria y te mantiene estancado
                mientras otros, con menos talento pero más arrojo, se quedan con
                las oportunidades."
              </p>
            </div>

            <div className="mt-8 pt-8 border-t border-zinc-800 flex items-center justify-between" data-id="element-127">
              <span className="font-mono text-xs text-zinc-500 uppercase tracking-widest" data-id="element-128">
                Fin de la transmisión
              </span>
              <div className="flex gap-1" data-id="element-129">
                {[1, 2, 3].map(i => <div key={i} className="w-1 h-4 bg-zinc-700" data-id="element-130"></div>)}
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}